import React, { ReactElement } from 'react';
import { ThemeTopBannerType } from '@/modules/types/theme';
import { useIsMobileScreenSize } from '@/lib/util';

const FrameTopBannerView = (topBanner: ThemeTopBannerType): ReactElement => {
  const { isMobile, isPortrait } = useIsMobileScreenSize();

  return (
    <div id="banner" className="canvas-topbanner">
      {((!isMobile && !topBanner.isMobileView) ||
        (isMobile && !isPortrait)) && (
        <div id="course-name" style={topBanner.metadata.elearningName}>
          {topBanner.title}
        </div>
      )}
    </div>
  );
};

export default FrameTopBannerView;
